import type Highcharts from "highcharts";

declare module "highcharts" {
  interface ChartEventsOptions {
    keydown?: (this: Highcharts.Chart, e: KeyboardEvent) => void;
  }
}

export default function keydownChartEvent(H: typeof Highcharts) {
  H.wrap(
    H.Chart.prototype,
    "init",
    function (
      this: Highcharts.Chart,
      proceed: { apply: (arg0: Highcharts.Chart, arg1: [Highcharts.Options]) => void },
      ...args: [Highcharts.Options]
    ) {
      proceed.apply(this, args);
      this.container.tabIndex = -1; // needed for keyboard events
      this.container.addEventListener("click", () => {
        if (!this.container.contains(document.activeElement))
          this.container.focus({ preventScroll: true });
      });
      this.container.addEventListener("keydown", e => H.fireEvent(this, "keydown", e));
    },
  );
}
